import { RoleEnum } from '@enum/role.enum';

export const initialAccountTeamForm = {
  name: '',
  email: '',
  role: RoleEnum.User,
};
